module.exports = __webpack_public_path__ + "img/rus_small_icon.6a4503cb.png";